import { render, staticRenderFns } from "./DirectoryFooter.vue?vue&type=template&id=499b4519&scoped=true"
import script from "./DirectoryFooter.vue?vue&type=script&lang=js"
export * from "./DirectoryFooter.vue?vue&type=script&lang=js"
import style0 from "./DirectoryFooter.vue?vue&type=style&index=0&id=499b4519&prod&lang=css"
import style1 from "./DirectoryFooter.vue?vue&type=style&index=1&id=499b4519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b4519",
  null
  
)

export default component.exports